import { PhoneCountryCodeType } from '@bus/models';
import { CompanyDetailsFormModel_OB_OL } from './formModel';

export const getInitialValues = (): CompanyDetailsFormModel_OB_OL => {
  return {
    tradingName: undefined,
    legalName: undefined,
    vatLiable: undefined,
    vatNumber: undefined,
    croNumber: undefined,
    dateOfIncorporation: undefined,
    businessType: undefined,
    businessSubType: undefined,
    countryCode: PhoneCountryCodeType.Ireland,
    phoneNumber: undefined,
    email: undefined,
    fleetSize: undefined,
    companyClassification: undefined,
    turnover: undefined,
  };
};
